module.exports = __webpack_public_path__ + "img/zz6.14002c42.png";